// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__XPQOf","buttons":"Password_buttons__3n7HR"};